import { icon } from '../../icons';
import { type PropertyDto, type TenantDto } from '../../services/api';
import { t } from '../../services/i18n';
import { esc } from './onboarding-shared';

export class RcOnboardingStepTenant extends HTMLElement {
  createdProperty: PropertyDto | null = null;
  createdTenant: TenantDto | null = null;
  createdTenantRentAmount: number | null = null;
  createdTenantStartDate: string | null = null;

  render(): void {
    const today = new Date().toISOString().split('T')[0];
    const existing = this.createdTenant;
    this.innerHTML = `
      <div class="wizard-step-content">
        <h1 class="wizard-step-title">${t('onboarding.tenant.title')}</h1>
        <p class="wizard-step-desc">${this.createdProperty
          ? t('onboarding.tenant.description', { property: this.createdProperty.displayName || this.createdProperty.address })
          : t('onboarding.tenant.descriptionNoProperty')}</p>
        <form id="wizard-form" class="wizard-form" novalidate>
          <div class="form-row">
            <div class="form-group">
              <label for="w-fname">${t('common.name')} <span class="required">*</span></label>
              <input id="w-fname" name="firstName" type="text" required placeholder="${t('onboarding.tenant.firstNamePlaceholder')}" value="${existing ? esc(existing.firstName) : ''}">
            </div>
            <div class="form-group">
              <label for="w-lname">${t('tenant.form.lastName')} <span class="required">*</span></label>
              <input id="w-lname" name="lastName" type="text" required placeholder="${t('onboarding.tenant.lastNamePlaceholder')}" value="${existing ? esc(existing.lastName) : ''}">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="w-email">${t('common.email')} <span class="optional">${t('common.optional')}</span></label>
              <input id="w-email" name="email" type="email" placeholder="${t('help.form.emailPlaceholder')}" value="${existing?.email ? esc(existing.email) : ''}">
            </div>
            <div class="form-group">
              <label for="w-phone">${t('common.phone')} <span class="optional">${t('common.optional')}</span></label>
              <input id="w-phone" name="phone" type="tel" placeholder="+32 470 00 00 00" value="${existing?.phone ? esc(existing.phone) : ''}">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="w-rent">${t('common.rentAmountPerMonth')} <span class="required">*</span></label>
              <input id="w-rent" name="rentAmount" type="number" required min="0" step="0.01" placeholder="750" value="${this.createdTenantRentAmount !== null ? this.createdTenantRentAmount : ''}">
            </div>
            <div class="form-group">
              <label for="w-start">${t('common.startDate')} <span class="required">*</span></label>
              <input id="w-start" name="startDate" type="date" required value="${this.createdTenantStartDate ?? today}">
            </div>
          </div>
          <div id="wizard-error" class="wizard-error" style="display:none"></div>
          <div class="wizard-actions">
            <button type="button" class="btn btn-outline wizard-prev-btn">
              ${icon('arrow-left', { size: 16, strokeWidth: 2.5 })}
              ${t('common.previous')}
            </button>
            <div class="wizard-actions-right">
              <button type="button" class="btn btn-outline wizard-skip-btn">${t('onboarding.skipStep')}</button>
              <button type="submit" class="btn btn-primary btn-lg wizard-next-btn">
                ${t('onboarding.tenant.next')}
                ${icon('arrow-right', { size: 16, strokeWidth: 2.5 })}
              </button>
            </div>
          </div>
        </form>
      </div>
    `;

    this.querySelector('.wizard-prev-btn')?.addEventListener('click', () => this.dispatchEvent(new CustomEvent('onboarding-prev', { bubbles: true })));
    this.querySelector('.wizard-skip-btn')?.addEventListener('click', () => this.dispatchEvent(new CustomEvent('onboarding-skip', { bubbles: true })));
    this.querySelector<HTMLFormElement>('#wizard-form')?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.dispatchEvent(new CustomEvent('onboarding-submit', {
        bubbles: true,
        detail: { form: event.currentTarget as HTMLFormElement },
      }));
    });
  }
}

if (!customElements.get('rc-onboarding-step-tenant')) {
  customElements.define('rc-onboarding-step-tenant', RcOnboardingStepTenant);
}
